import React from 'react';
import ReactDOM from 'react-dom';
import Dashboard from './App';

ReactDOM.render(
  <React.StrictMode>
    <Dashboard />
  </React.StrictMode>,
  document.getElementById('root')
);
